import initObserveAnimation from "./initObserveAnimation";
import initSplide from "./initSplide";

export default function initAnimation() {
  // viewport固定
  initObserveAnimation();

  //Splide関連
  initSplide();
}
